import { Component, h, Method, Prop } from '@stencil/core';
import axios from '../../../utils/get-axios';
import { $$$ } from '../../../utils/utils';
import { TealiumAddtoWishListEvent } from '../../../utils/tealium/TealiumAddToWishlistEvent';

declare const globals: any;

@Component({
  tag: 'lilu-header-wishlist',
  styleUrl: 'lilu-header-wishlist.scss',
  shadow: true,
})
export class LiluHeaderWishlist {
  @Prop() urlAdd: string;
  @Prop() urlRemove: string;
  @Prop() urlRemoveConfigurator: string;
  @Prop() count = '0';
  @Prop() link: string;
  @Prop() hasWishListQuery: boolean = false;

  componentWillLoad() {
    const urls = globals.urls;
    this.urlAdd = urls.wishlistAdd;
    this.urlRemove = urls.wishlistRemove;
    this.urlRemoveConfigurator = urls.wishlistRemoveConfiguration;

    const wishlistList = document.querySelector('lilu-wishlist-list');

    this.hasWishListQuery = wishlistList ? wishlistList.hasAttribute('wishlist-query') : false;
  }
  @Method()
  async addToWishlist(id: string) {
    let url = `${this.urlAdd}/${id}`;

    if (this.hasWishListQuery) {
      url += document.querySelector('lilu-wishlist-list').getAttribute('wishlist-query');
    }

    try {
      const response = await axios.get(url);

      this.count = response.data.whishlistCount;
      const emptyWishlist = $$$('lilu-empty-wishlist');
      const wishlist = $$$('lilu-wishlist-list');

      const updatedWishlist = this.htmlToElement(response.data.content);

      if (emptyWishlist.length > 0) {
        emptyWishlist[0].replaceWith(updatedWishlist);
      } else if (wishlist.length > 0) {
        wishlist[0].replaceWith(updatedWishlist);
      }

      new TealiumAddtoWishListEvent().executeLink(id);
    } catch (error) {
      console.error('Error adding to wishlist:', error);
    }
  }

  getRemoveRequestUrl(id: string, type = ''): string {
    let removeRequestUrl = '';

    if (type === 'configurator') {
      removeRequestUrl = this.urlRemoveConfigurator;
    } else {
      removeRequestUrl = this.urlRemove;
    }

    removeRequestUrl += `/${id}`;

    if (this.hasWishListQuery) {
      const wishListQuery = document.querySelector('lilu-wishlist-list').getAttribute('wishlist-query');
      removeRequestUrl += wishListQuery;
    }

    return removeRequestUrl;
  }

  @Method()
  async removeFromWishlist(id: string, type = '') {
    const removeRequestUrl = this.getRemoveRequestUrl(id, type);
    try {
      const response = await axios.get(removeRequestUrl);
      this.count = response.data.whishlistCount;

      const wishlist = $$$('lilu-wishlist-list');

      if (wishlist.length > 0) {
        const updatedWishlist = this.htmlToElement(response.data.content);
        wishlist[0].replaceWith(updatedWishlist);

        const wishlistButtons = $$$(`lilu-wishlist[product-id="${id}"]`);
        for (const button of wishlistButtons) {
          button.setAttribute('is-wishlist', 'false');
        }
      }
    } catch (error) {
      console.error('Error removing from wishlist:', error);
    }
  }

  /**
   * Generate a virtual DOM element from a HTML String an returns HTML Node
   * @param html string
   * @returns HTML Node
   */
  htmlToElement(html: string): ChildNode {
    const template: HTMLTemplateElement = document.createElement('template');
    html = html.trim(); // Never return a text node of whitespace as the result
    template.innerHTML = html;
    return template.content.firstChild;
  }

  render() {
    return (
      <lilu-link
        class=""
        color="dark"
        appearance="uppercase font-minus-4"
        icon={+this.count > 0 ? 'icon-heart-02' : 'icon-heart'}
        link={this.link}
        target="_self"
        size="size-18"
        font="bold"
      >
        {+this.count > 0 ? this.count : ''}
      </lilu-link>
    );
  }
}
